import { $Q } from 'graditify-utils';
import { createInterception } from '../sections/defer-js';
import './collection-card-template.scss';
import { initialLoadFilter } from './collections-card-filter';


createInterception($Q('.container-js'), () => initialLoadFilter());
